<template>
  <div class="invite-acceptance-container c-app flex-row align-items-center">
    <CContainer>
        <CRow class="justify-content-center">
            <CCol md="9">
                <CCardGroup>
                    <CCard class="p-4">
                        <CCardBody>
                            <p>プロジェクトへの招待を拒否しました。</p>
                            <p class="mb-5">プロジェクトへ参加する場合は、再度招待処理を行ってください。</p>

                            <CRow>
                                <CCol col="12" class="text-center mt-5">
                                    <CButton 
                                        @click="transitionProcess()"
                                        color="danger"
                                        class="px-4"
                                    >
                                        確認して、トップページへ
                                    ​</CButton>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </CCardGroup>
            </CCol>
        </CRow>
    </CContainer>
  </div>
</template>
<script>
export default {
    name: 'InviteDeny',

    data () {
        return {
            projectName: 'プロジェクトA​'
        }
    },
    methods: {
        transitionProcess (){
            window.location.href = this.$mimamoriBaseUrl + '/dashboard'
        }
    }
}
</script>